import React, { useState, useEffect } from "react";
import "../styles/App.css";
import Info from "./Info";
import { Technologies } from "./Technologies";
import SoftList from "./SoftList";
import ShortStory from "./ShortStory";
import Title from "./Title";
import Tools from "./Tools";
import { Projects } from "./Projects";
import { Parallax } from "react-parallax";
import { Language } from "./Language";
import pl from "../data/pl.json";
import eng from "../data/eng.json";
import { AvatarCard } from "../components/AvatarCard";
export const App = () => {
	const [language, setlanguage] = useState(pl);
	const [languageString, setlanguageString] = useState("pl");

	function toggleLanguage() {
		if (language === pl) {
			setlanguage(eng);
			setlanguageString("eng");
		} else {
			setlanguage(pl);
			setlanguageString("pl");
		}
	}

	return (
		<div className="App">
			<div
				style={{
					position: "fixed",
					width: "100vw",
					height: "100vh",
					top: "0",
					left: "0",
				}}
			></div>
			<Language
				toggleLanguage={() => {
					toggleLanguage();
				}}
			/>
			<div
				className="fb-customerchat"
				attribution="setup_tool"
				page_id="114864996731984"
			></div>
			<Parallax bgImage={require("../images/image1.png")} strength={600}>
				<div className="Parallax" style={{ width: "100vw", height: "70vh" }}>
					<AvatarCard language={languageString} />
				</div>
			</Parallax>
			<Projects language={languageString} />
			<Info text={language.Info} />
			<Technologies text={language.Technologies} />
			<Parallax
				bgImage={require("../images/image1.png")}
				style={{ width: "90vw", margin: "20", transform: "1" }}
				strength={800}
			>
				<div className="Container" id="tools">
					<div>
						<Title title={language.title2} />
						<Tools text={language.Tools} />
					</div>
					<div>
						<Title title={language.title1} />
						<SoftList text={language.SoftList} />
					</div>
				</div>
			</Parallax>
			<Title title={language.title3} />
			<ShortStory text={language.ShortStory} />
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/App.js